<template>
  <div class="ai-isloading">
    <img src="../../../assets/images/home/img1.gif" class="isloading" alt="">
    <div class="ai-loadingtxt">
      <div class="loadingtxt-txt">请耐心等待...</div>
      <div class="loadingtxt-txt">小助手正在努力为您查找相关内容~</div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
.ai-isloading {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  flex-wrap: wrap;

  .ai-loadingtxt {
    display: block;
    width: 100%;
    font-size: 12px;
    color: #949BA5;
    text-align: center;
    margin-top: 20px;
    line-height: 24px;
  }

  .isloading {
    width: 40px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/pageSearch/AIloading.vue